import { Component, inject } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  FIZICKI_OBJEKT_PARENT_FORM,
  FIZICKI_OBJEKT_PARENT_ITEM
} from '@app/components/pojavni-oblik/pojavni-oblik.component';
import { isFizickiObjekt } from '@app/shared/models/fizicki-objekt';
import { isPojavniOblik } from '@app/shared/models/pojavni-oblik';
import { log } from '@ntap/core';
import { combineLatest, debounceTime, map, startWith, switchMap } from 'rxjs';
import { PrimeNGButtonOpenItemViewActionComponent } from '@ntap/primeng';
import { withTooltipState } from '@app/shared/mixins/with-tooltip-state.mixin';

@Component({
  selector: 'app-new-direktorij-pojavnog-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class NoviDirektorijPojavnogActionComponent extends withTooltipState(
  PrimeNGButtonOpenItemViewActionComponent
) {
  pojavniFormService = inject(FIZICKI_OBJEKT_PARENT_FORM);
  parentItemViewProvider = inject(FIZICKI_OBJEKT_PARENT_ITEM);

  private readonly unsavedMessage =
    'Pojavni oblik nije spremljen. Spremite pojavni oblik kako bi mogli dodati direktorij.';

  protected override initDisabledObservable(): void {
    this.isDisabled$ = combineLatest([
      this.parentItemViewProvider.item$,
      this.pojavniFormService.formGroup$.pipe(
        switchMap((fg) =>
          fg.statusChanges.pipe(
            startWith({}),
            debounceTime(1),
            map(() => fg)
          )
        )
      )
    ]).pipe(map(([item, fg]) => this.calculateDisabled(item, fg)));
  }

  calculateDisabled(item: any, fg?: UntypedFormGroup): boolean {
    if (isPojavniOblik(item)) {
      const valid = fg?.status || 'INVALID';
      const itemIsActive = item['en~pojavni_oblik~status'] === 'A';
      if (!itemIsActive) {
        this.setTooltip(this.unsavedMessage);
      } else {
        this.setTooltip(null);
      }
      return valid !== 'VALID' || !itemIsActive;
    } else if (isFizickiObjekt(item)) {
      const valid = fg?.status || 'INVALID';
      return valid !== 'VALID';
    }
    log(
      'WARN: item is not PojavniOblik or FizickiObjekt for action that only works for PojavniOblik or FizickiObjekt shaped items!'
    );
    return true;
  }
}
